import db from "@/database";

export const findAll = () => db.oligoelementsType.toArray();
